import { pubsub } from "utils";
import EdgenDrawerCallable from "@components/EdgenDrawerCallable";
import { getBridge } from "@/src/lib/bridge/bridge";
import { isInNativeChatShellModal } from "@/src/lib/bridge/shellAppNavigation";
import { ChatStore } from "@store/modules/chat";
import { pubSubKeyMap } from "@utils/pubSubKeyMap";

/** 与 `EdgenDrawerCallable` createCallable timeout 一致 */
export const CHAT_OVERLAY_CLOSE_ANIMATION_MS = 200;

export type CloseActiveChatOverlayOptions = {
  /** Drawer 动画结束或原生 dismiss 发出后执行 */
  onClosed?: () => void;
};

/**
 * 关闭当前 Chat overlay。
 * 与 `useOpenChatModal` 的 `onCloseClick`、`ChatModalContent.handleClose` 行为对齐。
 */
export function closeActiveChatOverlay(
  options?: CloseActiveChatOverlayOptions,
): void {
  if (typeof window === "undefined") {
    return;
  }

  if (isInNativeChatShellModal()) {
    getBridge().dismissShellChat();
    options?.onClosed?.();
    return;
  }

  pubsub.emit(pubSubKeyMap.CHAT_DRAWER_STATE_CHANGE, false);
  EdgenDrawerCallable.update({ isOpen: false });

  setTimeout(() => {
    if (!ChatStore.loading) {
      EdgenDrawerCallable.end(false);
      ChatStore.hasChatModal = false;
    }
    options?.onClosed?.();
  }, CHAT_OVERLAY_CLOSE_ANIMATION_MS);
}
